import React from 'react';

import { QA_OTHERS_NOTE } from './params';

// A QA row's other issues on the class and the note that clearing QA leaves them open.
const QaOthers = ({ text, className = 'tp-c-line tp-na-detail' }) =>
  text ? (
    <div className={className}>
      <div>{text}</div>
      <div className="tp-sub">{QA_OTHERS_NOTE}</div>
    </div>
  ) : null;

export default QaOthers;
